<style scoped>
	.siimg {
		width: 24px;
		height: 24px;
		margin-top: 8px;
		margin-left: calc(50% - 12px);
	}

	.siimg img {
		width: 100%;
		height: 100%;
	}

	.sititle {
		font-size: 16px;
		color: #979797;
	}

	.sidetail {
		font-size: 12px;
		color: #979797;
	}

	#allmap {
		height: 500px;
		width: 100%;
	}

	#termialDetail .el-row {
		margin-bottom: 20px;
	}

	#termialDetail .el-form-item-left {
		display: inline-block;
		vertical-align: top;
		margin: 5px 10px;
		width: 50%;
		border-bottom: 1px solid #e5e9f2;
		font-size: 18px;
	}

	#termialDetail .el-form-item-right {
		display: inline-block;
		vertical-align: top;
		margin: 5px 10px;
		min-width: 45%;
		border-bottom: 1px solid #e5e9f2;
		font-size: 18px;
	}

	#termialDetail .el-card__header {
		background-color: #eef1f6;
	}

	.ml5 {
		margin-right: 5px;
	}
</style>
<template>

	<div v-if='mapDialog'>
		<el-row>
			<i @click="mapDialog = false" class='el-icon-close' style='margin-bottom:10px;float:right;'></i>
		</el-row>
		<div id="allmap" v-if='isChina'></div>
		<div class='' v-else id="gmap" style="height:500px;"></div>
	</div>

	<div v-else id="termialDetail" v-loading="disabled">




		<tyc :tqobj='tqobj'></tyc>

		<el-dialog :title="$t('lin_btn.tips')" v-model="showReset" class='gDia' :before-close="handleClose">
			<span>{{this.$t('lin_global.qrjxmm') + this.$t('terminal.details.regain')}}</span>
			<span slot="footer" class="dialog-footer">
				<el-button @click="showReset = false">{{$t('app_cancel')}}</el-button>
				<el-button type="primary" @click="opeTer('1')">{{$t('app_tipterop')}}</el-button>
				<el-button type="primary" @click="opeTer('0')">{{$t('app_autocmpl')}}</el-button>
			</span>
		</el-dialog>


		<el-dialog @close="showdvst=false" class='gDia' :title="$t('lin_global.ter_status')" v-model="showdvst" size=""
			top="15%">
			<el-table :data="getTerWllxInfo.extendStatus" border style="width: 100%">
				<el-table-column prop="name" width="220" label="Name">
				</el-table-column>
				<el-table-column prop="type" width="180" label="Type">
				</el-table-column>
				<el-table-column prop="status" label="Status">
				</el-table-column>
			</el-table>
		</el-dialog>


		<el-dialog @close="showlog = false" class='gDia' :title="$t('app_mdclst')" v-model="showlog" size="" top="15%">
			<el-table v-loading='sendLoad' class='tbPoint' :data="mdlogs" @row-click="showFunc" border
				style="width: 100%">
				<el-table-column prop="name" width="320" :label="$t('app_name')">
				</el-table-column>
				<el-table-column prop="value" width="120" :label="$t('app_param')">
				</el-table-column>
			</el-table>
		</el-dialog>


		<el-dialog @close="showfc=false;fclogs=[]" class='gDia' :title="$t('app_fcclst')" v-model="showfc" size=""
			top="15%">
			<el-table :data="fclogs" border style="width: 100%">
				<el-table-column prop="name" width="320" :label="$t('app_name')">
				</el-table-column>
				<el-table-column prop="value" width="120" :label="$t('app_param')">
				</el-table-column>
			</el-table>
		</el-dialog>


		<el-dialog @close="closeulDia" class='gDia' :title="ulscreentt" v-model="ulDia" size="tiny" top="15%">
			<el-form>
				<el-form-item>
					<el-input v-model="ulsform.psw" type="password" :placeholder="$t('lin_global.password')"></el-input>
				</el-form-item>
				<el-form-item>
					<el-input v-model="ulsform.time" :placeholder="$t('app_wattime') + ' ' + $t('app_perms')">
					</el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="closeulDia">{{$t('app_cancel')}}</el-button>
				<el-button :disabled="!ulsform.psw || !ulsform.time" type="primary" @click="ulscreenRqs()">
					{{$t('app_confirm')}}
				</el-button>
			</div>
		</el-dialog>

		<div>
			<el-row>
				<el-col :span='24'>

					<span class="wrapper">
						<el-button-group style="margin-right: 8px;">

							<el-button :disabled="btnShow" type="warning" size="small" :loading="cqLoad"
								@click="orderExec('CQ')" id="orderExecCQ"><span><i
										class="fa fa-spinner ml5"></i>{{$t('lin_btn.restart')}}</span></el-button>

							<el-button :disabled="btnShow" type="danger" size="small" :loading="gjLoad"
								@click="orderExec('GJ')" id="orderExecGJ"><span><i
										class="fa fa-power-off ml5"></i>{{$t('terminal.details.gj')}}</span></el-button>
						</el-button-group>

						<!--<el-button :disabled="btnShow" type="primary" size="small" :loading="hfszLoad"  @click="orderExec1('HFCCSZ')"><span><i class="fa fa-refresh ml5"></i>{{$t('terminal.details.regain')}}</span></el-button>-->
						<el-button :disabled="btnShow" type="primary" size="small" :loading="hfszLoad"
							@click="showReset = true"><span><i
									class="fa fa-refresh ml5"></i>{{$t('terminal.details.regain')}}</span></el-button>

						<el-button type="primary" size="small" @click="processInfoVisible=true" id="processInfo">
							<span><i class="fa fa-pencil ml5"></i>{{$t('lin_btn.edit')}}</span>
						</el-button>

						<!--<el-button :disabled="btnShow" @click="clickAbd" :loading="adbLoad" type="primary" size="small">
                           <span><i class="fa fa-cog ml5"></i>{{adb}}</span>
                        </el-button>-->


						<!-- <el-button :disabled="btnShow" @click="ToLinkLog" type="primary" size="small" id="processInfo">
                    	  	<span><i class="fa fa-file-text ml5"></i>{{$t('terminal.details.run_log')}}</span>
                    	  </el-button>-->

						<!--<el-button type="default" size="mini" :loading="zjLoad"  @click="orderExec1('ZJ')">自检</el-button>-->

						<!--  <el-button type="default" size="mini">
                             <router-link to="/terOta" style="text-decoration: none;color: #1f2d3d">锁定OTA</router-link>
                           </el-button> -->
						<!-- <el-button :disabled="btnShow" @click="linkRisk" type="primary" size="small">
                          <span><i class="fa fa-exclamation-circle ml5"></i>{{$t('terminal.details.risk_info')}}</span>
                        </el-button> -->
						<el-button-group style="margin-right: 8px;margin-left:8px;">

							<el-button :disabled="btnShow" @click="ToLinkList" type="primary" size="small">
								<span><i class="fa fa-list ml5"></i>{{$t('terminal.details.app_list')}}</span>
							</el-button>

							<el-button @click="ToLink" type="primary" size="small">

								<span><i class="fa fa-cogs ml5"></i>{{$t('terminal.details.app_install')}}</span>
							</el-button>

						</el-button-group>


						<el-button-group>

							<el-button type="primary" @click="sendAnimate" size="small">
								<span><i class="fa fa-upload ml5"></i>{{$t('terminal.details.send_animate')}}</span>
							</el-button>
							<el-button :disabled="btnShow" type="primary" @click="animate" size="small">
								<span><i class="fa fa-repeat ml5"></i>{{$t('terminal.details.reset_animate')}}</span>
							</el-button>

						</el-button-group>


						<el-button style='margin-left:8px;' type="primary" @click="showPathMap" size="small">
							{{$t('app_trjmap')}}
						</el-button>

						<el-button v-if="baseinfo.lock_status != 1" style='margin-left:8px;' type="primary"
							@click="lockDevice(true)" size="small">
							{{$t('app_lockdevice')}}
						</el-button>

						<el-button v-else style='margin-left:8px;' type="primary" @click="lockDevice(false)"
							size="small">
							{{$t('app_unlockdevice')}}
						</el-button>

						<el-button style='margin-left:8px;' type="primary" @click="callclick" size="small">
							{{calltt}}
						</el-button>

						<el-button style='margin-left:8px;' type="primary" @click="outputexcel" size="small">
							{{$t('app_opterinfo')}}
						</el-button>

						<el-button style='margin-left:8px;' type="primary" @click="ulscreenOpe" size="small">
							{{ulscreentt}}
						</el-button>
					</span>

					<el-button-group style="margin-right: 8px;margin-left:8px;">
						<el-button @click="showlog = true" type="primary" size="small">
							{{$t('app_lulog')}}
						</el-button>
						<el-button @click="showdvst = true" type="primary" size="small">
							{{$t('app_lust')}}
						</el-button>
					</el-button-group>

				</el-col>
			</el-row>

			<el-alert v-show='showFac' :title="this.$t('app_saleSt') + '：' + this.$t('app_noresetfs')" type="error">
			</el-alert>
			<el-alert v-show='showAct'
				:title="this.$t('app_actst') + '：' + this.$t('app_selfDestroy') + '(' + baseinfo.activDesc + ')'"
				type="error">
			</el-alert>

			<el-row>
				<el-col :span='24'>
					<el-card class="box-card">
						<div slot="header" class="clearfix" style="height:10px;">
							<span style="line-height: 16px;">{{$t('terminal.details.base_info')}}</span>
						</div>
						<el-form v-model="baseinfo" id="" label-position="left" inline label-width="120px">
							<el-form-item :label="$t('lin_global.label_name')" class="el-form-item-left">
								{{ baseinfo.terminal_name }}
							</el-form-item>
							<el-form-item :label="$t('lin_global.label_no')" class="el-form-item-right">
								{{ baseinfo.terminal_no }}
							</el-form-item>
							<el-form-item :label="$t('lin_global.label_type')" class="el-form-item-left">
								{{ baseinfo.terminal_typeName }}
							</el-form-item>
							<el-form-item :label="$t('lin_global.label_model')" class="el-form-item-right">
								{{ baseinfo.terminal_modelName }}
							</el-form-item>
							<el-form-item :label="$t('lin_global.label_areaid')" class="el-form-item-left">
								{{ baseinfo.mechanismName }}
							</el-form-item>
							<el-form-item :label="$t('lin_global.label_manufid')" class="el-form-item-right">
								{{ baseinfo.manufName }}
							</el-form-item>
							<el-form-item :label="$t('lin_global.guojia')" class="el-form-item-left">
								{{ baseinfo.nation }}
							</el-form-item>
							<el-form-item :label="$t('lin_global.shengfen')" class="el-form-item-right">
								{{baseinfo.province}}
							</el-form-item>
							<el-form-item :label="$t('lin_global.city')" class="el-form-item-left">
								{{ baseinfo.city }}
							</el-form-item>
							<el-form-item :label="$t('app_region')" class="el-form-item-right">
								{{baseinfo.district}}
							</el-form-item>
							<el-form-item :label="$t('lin_global.label_address')" class="el-form-item-left">
								{{ baseinfo.address }}
							</el-form-item>
							<el-form-item :label="$t('lin_global.remark')" class="el-form-item-right">
								{{baseinfo.memo}}
							</el-form-item>
						</el-form>
					</el-card>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span='24'>
					<el-card class="box-card">
						<div slot="header" class="clearfix" style="height:10px;">
							<span style="line-height: 16px;">{{$t('app_stinfo')}}</span>
							<i class='fa fa-refresh' @click='rfNet'
								style='color:#20A0FF;margin-top:-20px;margin-left:20px;'></i>
						</div>
						<div style="height:90px;width:100%;">
							<div v-show='baseinfo.online_history'
								style="margin-top:20px;left:17.166%;height:2px;width:65.766%;background:#9BD4FF;position:absolute;">
							</div>
							<el-row style='width:100%;background:none;' v-loading="peripheralLoading">
								<el-col :span='8' style="text-align:center">
									<div class='siimg'>
										<img :src='sticon0'>
									</div>
									<div class='sititle' style='margin-top:8px;'>{{stlb0}}</div>
									<div class='sidetail' style='margin-top:6px;'>{{sttm0}}</div>
								</el-col>
								<el-col :span='8' style="text-align:center">
									<div class='siimg'>
										<img :src='sticon1'>
									</div>
									<div class='sititle' style='margin-top:8px;'>{{stlb1}}</div>
									<div class='sidetail' style='margin-top:6px;'>{{sttm1}}</div>
								</el-col>
								<el-col :span='8' style="text-align:center">
									<div class='siimg'>
										<img :src='sticon2'>
									</div>
									<div class='sititle' style='margin-top:8px;'>{{stlb2}}</div>
									<div class='sidetail' style='margin-top:6px;'>{{sttm2}}</div>
								</el-col>
							</el-row>
						</div>
					</el-card>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span='24'>
					<el-card class="box-card">
						<div slot="header" class="clearfix" style="height:10px;">
							<span style="line-height: 16px;">{{$t('lin_global.ter_status')}}</span>
							<i class='fa fa-refresh' @click='rfNet'
								style='color:#20A0FF;margin-top:-20px;margin-left:20px;'></i>
						</div>
						<el-form v-loading="peripheralLoading" id="baseInfo" label-position="left" inline
							label-width="120px">
							<el-form-item :label="$t('lin_global.net_status')" class="el-form-item-left">


								<el-tag v-if="getTerWllxInfo.terminal_status === '1' " type="success" size="mini">
									{{$t('lin_global.online')}}
								</el-tag>
								<el-tag v-if="getTerWllxInfo.terminal_status === '2' " type="danger" size="mini">
									{{$t('lin_global.offline')}}
								</el-tag>
								<el-tag v-if="getTerWllxInfo.terminal_status === '0' " type="gray" size="mini">
									{{$t('lin_global.new_add')}}
								</el-tag>
								<el-tag v-if="getTerWllxInfo.terminal_status === '3' " type="warning" size="mini">
									{{$t('app_sleep')}}
								</el-tag>
								<el-tag v-if="getTerWllxInfo.terminal_status === '4' " type="danger" size="mini">
									{{$t('lin_btn.lock')}}
								</el-tag>
							</el-form-item>
							<el-form-item :label="$t('lin_global.run_status')" class="el-form-item-right">
								<el-tag v-if="baseinfo.terminal_runtime_status === '0' " type="success" size="mini">
									{{$t('lin_global.normal')}}
								</el-tag>
								<el-tag v-else type="warning" size="mini">{{showRuntime}}</el-tag>
							</el-form-item>
							<el-form-item :label="$t('terminal.details.net_type')" class="el-form-item-left">
								{{getTerWllxInfo.wlan}}
							</el-form-item>
							<el-form-item :label="$t('lin_global.ter_status')" class="el-form-item-right">
								{{ baseinfo.lock_status == 1?$t('lin_btn.lock') : $t('lin_global.normal') }}
							</el-form-item>


						</el-form>
					</el-card>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span='24'>
					<el-card class="box-card">
						<div slot="header" class="clearfix" style="height:10px;">
							<label style="line-height: 16px;">{{$t('terminal.details.system_info')}}</label>
							<i v-show='isRf' class='fa fa-refresh' @click='rfInfo'
								style='color:#20A0FF;margin-top:-20px;margin-left:20px;'></i>
							<!-- <el-button type='primary' size=small style='margin-top:-20px;margin-left:20px;' @click='rfInfo'></el-button> -->
						</div>
						<el-form v-loading="systemInfoLoading" id="getTerXtxxInfo" label-position="left" inline
							label-width="120px">
							<!-- <el-form-item label="系统信息">
                    {{ systemInfo }}
                  </el-form-item> -->
							<el-form-item :label="$t('terminal.details.launcher')" class="el-form-item-left">
								{{getTerXtxxInfo.launcher}}
							</el-form-item>
							<el-form-item :label="$t('terminal.details.system_version')" class="el-form-item-right">
								{{hardwareInfo.system}}
							</el-form-item>
							<el-form-item :label="$t('terminal.details.ota_version')" class="el-form-item-left">
								{{getTerXtxxInfo.ota}}
							</el-form-item>
							<el-form-item :label="$t('terminal.details.hard_version')" class="el-form-item-right">
								{{getTerXtxxInfo.firmware}}
							</el-form-item>
							<el-form-item :label="$t('terminal.details.last_time')" class="el-form-item-left">
								{{baseinfo.terminal_online_time}}
							</el-form-item>
							<el-form-item :label="$t('terminal.details.run_time')" class="el-form-item-right">
								{{getTerXtxxInfo.elapsedtime}}
							</el-form-item>
							<el-form-item :label="$t('app_comptime')" class="el-form-item-left">
								{{baseinfo.compile?baseinfo.compile:'-'}}
							</el-form-item>
							<el-form-item label="IMEI" class="el-form-item-right">
								{{getTerXtxxInfo.imei}}
							</el-form-item>

						</el-form>
					</el-card>
				</el-col>
			</el-row>
			<!-- <el-row> // net
        <el-col :span='24'>
          <el-card class="box-card">
            <div slot="header" class="clearfix" style="height:10px;">
              <label style="line-height: 16px;">{{$t('lin_global.net_status')}}</label>
              <i v-show='isRf' class='fa fa-refresh' @click='rfNet' style='color:#20A0FF;margin-top:-20px;margin-left:20px;'></i>

            </div>
            <el-form v-loading="peripheralLoading" id="systemInfo" label-position="left" inline label-width="120px">
              <el-form-item :label="$t('terminal.details.net_type')">
                {{getTerWllxInfo.wlan}}
              </el-form-item>
              <el-form-item :label="$t('terminal.details.run_time')">
                 {{getTerXtxxInfo.elapsedtime}}
              </el-form-item>
            </el-form>
          </el-card>
        </el-col>
      </el-row> -->
			<el-row>
				<el-col :span='24'>
					<el-card class="box-card">
						<div slot="header" class="clearfix" style="height:10px;">
							<label style="line-height: 16px;">{{$t('terminal.details.hard_info')}}</label>
							<i v-show='isRf' class='fa fa-refresh' @click='rfhw'
								style='color:#20A0FF;margin-top:-20px;margin-left:20px;'></i>
							<!-- <el-button type='primary' size=small style='margin-top:-20px;margin-left:20px;' @click="rfhw"></el-button> -->
						</div>
						<el-form v-loading="hardInfoLoading" id="hardInfo" label-position="left" inline
							label-width="120px">
							<el-form-item :label="$t('terminal.details.cpu')" class="el-form-item-left">
								{{ hardwareInfo.cpu }}
							</el-form-item>
							<el-form-item :label="$t('terminal.details.mem')" class="el-form-item-right">
								{{ hardwareInfo.mem }}
							</el-form-item>

							<el-form-item :label="$t('terminal.details.cpuUsed')" class="el-form-item-left">
								{{ hardwareInfo.cpuUsed }}
							</el-form-item>
							<el-form-item :label="$t('terminal.details.memUsed')" class="el-form-item-right">
								{{ hardwareInfo.memUsed }}
							</el-form-item>

						</el-form>
					</el-card>
				</el-col>
			</el-row>


			<!-- adb  -->
			<el-row>
				<el-col :span='24'>
					<el-card class="box-card">
						<div slot="header" class="clearfix" style="height:10px;">
							<label style="line-height: 16px;">{{$t('app_debuginfo')}}</label>
							<i v-show='isRf' class='fa fa-refresh' @click='rfadb'
								style='color:#20A0FF;margin-top:-20px;margin-left:20px;'></i>

						</div>
						<el-form v-loading="adbLoading" id="hardInfo" label-position="left" inline label-width="120px">
							<el-form-item :label="$t('app_adbstatus')" class="el-form-item-left">
								<el-tag type="success" size="mini">{{adbst}}</el-tag>
							</el-form-item>
							<el-form-item :label="$t('app_signstatus')" class="el-form-item-right">
								<el-tag type="success" size="mini">{{signst}}</el-tag>
							</el-form-item>

							<el-form-item :label="$t('app_devicemode')" class="el-form-item-left">
								{{dvst}}
							</el-form-item>
							<!-- <el-form-item :label="$t('terminal.details.memUsed')" class="el-form-item-right">
                {{ hardwareInfo.memUsed }}
              </el-form-item> -->
							<el-form-item :label="$t('app_cerid')" class="el-form-item-right">
								{{ getTerAdbztInfo.certInfo }}
							</el-form-item>

						</el-form>
					</el-card>
				</el-col>
			</el-row>
		</div>

		<processInfo v-if="processInfoVisible" :pdata="pdata"></processInfo>
		<!-- <processInfo v-if="processInfoVisible" :terminalNo="terminalID"></processInfo> -->
		<el-dialog class='gDia' :title="$t('terminal.details.hydh')" v-model="animateDialog" size="tiny" top="15%">
			<el-form>
				<el-form-item style="width:98%">
					<el-select v-model="animateId" :placeholder="$t('terminal.details.tips')" style="width:100%">
						<el-option :label="$t('terminal.details.kjdh')" value="1"></el-option>
						<el-option :label="$t('terminal.details.gjdh')" value="2"></el-option>
						<el-option :label="$t('terminal.details.kjlogo')" value="3"></el-option>
						<el-option :label="$t('app_wallpaper')" value="0"></el-option>
						<!-- <el-option :label="$t('terminal.details.alldhlogo')" value="4"></el-option> -->
					</el-select>
				</el-form-item>


			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="onCancel">{{$t('terminal.details.zbhy')}}</el-button>
				<el-button :loading="logining" type="primary" @click="submit">{{$t('terminal.details.mshy')}}
				</el-button>
			</div>
		</el-dialog>

		<el-dialog class="gDia" :title="$t('terminal.details.tsdh_title')" v-loading.body="sendLoad"
			v-model="sendAnimateDialog" top="15%">
			<el-table :data="tableData" v-loading="tloading" border style="width: 100%">
				<el-table-column prop="fileName" :label="$t('terminal.details.animate_name')">
				</el-table-column>
				<!-- <el-table-column
          prop="animatType"
          :label="$t('terminal.details.animatType')"
          :formatter="statusType">
        </el-table-column> -->
				<el-table-column prop="position" :label="$t('terminal.details.animatType')" :formatter="formatStatus">
				</el-table-column>
				<el-table-column prop="createTime" :label="$t('terminal.details.createTime')" width="170">
				</el-table-column>
				<el-table-column :label="$t('lin_global.ope')" width="81">
					<template slot-scope="scope">
						<!-- <el-button
              size="small"
              @click="send(scope.row.animatId)">{{$t('lin_btn.send')}}</el-button> -->

						<el-tooltip class="item" effect="dark" :content="$t('lin_btn.send')" placement="top">
							<el-button type='text' @click="send(scope.row)"><i class="fa fa-upload" style=""></i>
							</el-button>
						</el-tooltip>

					</template>
				</el-table-column>
			</el-table>
		</el-dialog>

		<el-dialog class='gDia' :title="$t('lin_global.hqrz')" v-model="logDialog" top="15%">
			<el-form>
				<el-row :gutter="10" type="flex" align="bottom">
					<el-col :span="10">
						{{$t('terminal.appLog.start_time')}}
						<el-date-picker type="date" @change="dataChange" clearable
							:placeholder="$t('terminal.appLog.start_time')" v-model="start_time"></el-date-picker>
					</el-col>

					<el-col :span="10">
						{{$t('terminal.appLog.end_time')}}
						<el-date-picker type="date" @change="dataChange1" clearable
							:placeholder="$t('terminal.appLog.end_time')" v-model="end_time"></el-date-picker>
					</el-col>
					<el-col :span="4">
						<el-button type="primary" :loading="logLoad" @click="getLog">{{$t('lin_global.hqrz')}}
						</el-button>
					</el-col>
				</el-row>
			</el-form>
		</el-dialog>


		<el-dialog class='gDia' :title="$t('app_trjmap')" top="15%">
			<el-row class='' v-if='isChina'>
				<el-col :span="24">
					<zt-map height="480" :mapdata1="mapdata1" :mode='1'></zt-map>
				</el-col>
			</el-row>

			<div class='' v-else id="gmap" style="height:480px;"></div>
		</el-dialog>



		<div class='gPageBorder gTopMg'>
			<!-- list -->
			<p class='gPTitle'>{{$t('app_taskMg ')}}</p>

			<el-row>
				<el-col :span='16'>
					<div class='gSgLeftBtn'>
						<el-button type="primary" @click="refreshList">{{$t('lin_global.shuaxin')}}</el-button>
					</div>
				</el-col>
				<el-col :span='4'>
					<div class='gSgLeftBtn'>
						<el-select v-model="taskType" clearable :placeholder="$t('app_taskType')"
							@change='selectChange'>
							<el-option v-for="item in statusSl" :key="item.type" :label="item.name" :value="item.type">
							</el-option>
						</el-select>
					</div>
				</el-col>
				<el-col :span='4'>
					<div class='gSideCtrl' style="margin-left:16px;">
						<el-input :placeholder="$t('app_taskDetail')" @keyup.enter.native='query' v-model='tName'
							icon='search' :on-icon-click='query'></el-input>
					</div>
				</el-col>

			</el-row>

			<div id='cmData'>
				<el-table class='gTopMg' ref="multipleTable" :data="tableData1" border
					@selection-change="handleSelectionChange" style="width: 100%">
					<!-- <el-table-column
                align=center
                type="selection"
                width="55">
            </el-table-column> -->

					<el-table-column header-align='center' align='center' prop="fileName" :label="$t('app_taskDetail')"
						width="">
						<template slot-scope='scope'>
							<label v-if='scope.row.taskType == 19'>{{comm[scope.row.fileName]}}</label>
							<label v-else>{{scope.row.fileName}}</label>
						</template>
					</el-table-column>
					

					<!-- <el-table-column
              header-align='center'
              align='center'
              prop="version"
              :label="$t('app_version')"
              width="">
            </el-table-column> -->

					<el-table-column header-align='center' align='center' prop="taskType" :label="$t('app_taskType')"
						width="">
						<template slot-scope='scope'>
							<label>{{statusShow[scope.row.taskType]}}</label>
						</template>
					</el-table-column>

					<el-table-column header-align='center' align='center' prop="progress" :label="$t('app_process')"
						width="">
						<template slot-scope=scope>
							<label>{{scope.row.progress}}%</label>
						</template>
					</el-table-column>



					<el-table-column header-align='center' align='center' :label="$t('app_status')" width="">
						<template slot-scope='scope'>
							<label typy="success">{{statusNames[scope.row.status + '']}}</label>
						</template>
					</el-table-column>

					<el-table-column header-align='center' align='center' prop="updateTime" :label="$t('app_pushTime')"
						width="176">

					</el-table-column>

					<el-table-column header-align='center' align=right prop="cancelNums" :label="$t('app_operate')"
						width="116">
						<template slot-scope='scope'>



							<el-tooltip class="item" effect="dark" :content="$t('app_pause')" placement="top">
								<el-button type='text' v-show='showBtn(1, scope.row.status)'
									@click='downOperate(2, scope.row)'><i class="fa fa-pause" style=""></i></el-button>
							</el-tooltip>

							<el-tooltip class="item" effect="dark" :content="$t('app_continue')" placement="top">
								<el-button type='text' v-show='showBtn(2, scope.row.status)'
									@click='downOperate(1, scope.row)'><i class="fa fa-play" style=""></i></el-button>
							</el-tooltip>


							<el-tooltip class="item" effect="dark" :content="$t('app_ccdown')" placement="top">
								<el-button type='text' v-show='showBtn(3, scope.row.status)'
									@click='downOperate(3, scope.row)'><i class="fa fa-window-close" style=""></i>
								</el-button>
							</el-tooltip>

							<el-tooltip class="item" effect="dark" :content="$t('lin_global.chongtui')" placement="top">
								<el-button type='text' v-show='showBtn(4, scope.row.status)' @click='repush(scope.row)'>
									<i class="fa fa-repeat" style=""></i>
								</el-button>
							</el-tooltip>

							<!-- <el-tooltip v-show='false' class="item" effect="dark" :content="$t('app_del')" placement="top">
                  <el-button type='text' v-show='showBtn(0, scope.row.status)' @click='delRow(scope.row)'><i class="fa fa-trash-o" style="color:#FF4949"></i></el-button>
                </el-tooltip> -->

						</template>
					</el-table-column>
				</el-table>
			</div>

			<div class='gPgDiv'>


				<el-pagination class='gPg' @current-change="pageSelectDv" @size-change="pageSized" :current-page="index"
					:page-sizes='$gRows' :page-size="row" layout="total, sizes, prev, pager, next, jumper"
					:total="total">
				</el-pagination>
			</div>

		</div>
	</div>

	</div>
</template>
<script>
	var iconRed = require("../../assets/images/icon_red.png");
	var iconGreen = require("../../assets/images/icon_green.png");
	var iconGray = require("../../assets/images/icon_gray.png");
	var iconYellow = require("../../assets/images/icon_yellow.png");
	import ztMap from "../index/ztMap";
	import $ from "jquery";
	import axios from "axios";
	import {
		baseurl
	} from "../../api/url";
	import processInfo from "./processInfo.vue";

	import tyc from '@/components/global/tyc.vue'

	import don from '@/assets/images/don.svg'
	import doff from '@/assets/images/doff.svg'
	import dsleep from '@/assets/images/dsleep.svg'
	export default {
		data() {
			var that = this;
			return {
				tqobj: '',
				mdlogs: [],
				fclogs: [],
				showdvst: false,
				showlog: false,
				showfc: false,
				subtypes: [],
				sticons: [
					don, doff, dsleep
				],
				norword: [
					this.$t('app_croln'),
					this.$t('app_croff'),
					this.$t('app_crslp')
				],
				lasword: [
					this.$t('app_lstol'),
					this.$t('app_lstof'),
					this.$t('app_lstsl')
				],
				mapdata1: {
					sn: "",
					page: 1,
					rows: 300,
					status: "",
					runStatus: ""
				},
				showFac: false,
				showAct: false,
				showReset: false,
				mapDialog: false,
				ulDia: false,
				ulsform: {
					psw: '',
					time: ''
				},
				dur: 6000,
				btnShow: true,
				isRf: false,
				start_time: "",
				end_time: "",
				total: 0,
				comm: '',
				rType: {
					"0": this.$t("app_normal"),
					"1": this.$t("app_fault"),
					"2": this.$t("app_abnormal"),
					"3": this.$t("app_blockp")
				},
				rRuntime: {
					"1": this.$t("app_ecr"),
					"2": this.$t("app_mcr"),
					"3": this.$t("app_nacr"),
					"4": this.$t("app_cardr"),
					"5": this.$t("app_tgcr"),
					"6": this.$t("app_receiptp")
				},
				tName: "",
				statusNames: {
					// add by sing, 2017-06-17
					"-1": this.$t("app_downFail"),
					"-2": this.$t("app_md5Fail"),
					"-3": this.$t("app_theNewgVer"),
					"-4": this.$t("app_fileFmIllegal"),
					"-5": this.$t("app_updateFail"),
					"-6": this.$t("app_usrCancelUpdate"),
					"0": this.$t("app_pushFail"),
					"1": this.$t("app_downloading"),
					"2": this.$t("app_downFinish"),
					"3": this.$t("app_success"),
					'4': this.$t('app_waiting'),
					"5": this.$t("app_success"),
					"6": this.$t("app_pause"),
					"7": this.$t("app_ccdown"),
					"-7": this.$t("app_verror"),
					"-8": this.$t("app_insfail"),
					"-9": this.$t("app_checksignfail"),
					"-10": this.$t("app_uninsfail"),
					'12': this.$t('app_appuninstall')
				},
				statusShow: '',
				statusSl: '',
				taskType: "",
				pageTag: "terDetailPage",
				logDialog: false,
				logLoad: false,
				adbLoad: false,
				cqLoad: false,
				gjLoad: false,
				hfszLoad: false,
				zjLoad: false,
				logining: false,
				sendLoad: false,
				tloading: false,
				disabled: true,
				adb: this.$t("terminal.details.open_abd"),
				abdOpe: "0",
				hardwareInfo: {},
				systemInfoLoading: false,
				hardInfoLoading: false,
				peripheralLoading: false,
				adbLoading: false,
				tableData: [],
				tableData1: [],
				animateId: "",
				animateDialog: false,
				sendAnimateDialog: false,
				importTermVisible: false,
				linkto: `/terList/${this.$route.params.id}/terAppList`,
				linkBind: "",
				execNo: "",
				baseinfo: {},
				getTerXtxxInfo: {},
				getTerWllxInfo: {},
				getTerAdbztInfo: {},
				statusinfo: {},
				hardInfo: {},
				systemInfo: null,
				terminalNo: "",
				terminalID: this.$route.params.id,
				processInfoVisible: false,
				detailInfo: [],
				linkLog: "",
				terNo: "",
				pdataChange: this.$store.getters.edit_change,
				pdata: {
					mechanismName: '',
					isChange: this.$store.getters.edit_change,
					terminalID: this.$route.params.id,
					terminalNO: "",
					terminal_name: "",
					terminal_model: "",
					terminal_type: "",
					areaid: "",
					manufid: "",
					address: ""
					/*,
					          pdataFinsh: 'false'*/
				}
			};
		},
		watch: {
			/*'pdata.pdataFinsh' () {
			   this.fetchData()
			   }*/
			"pdata.isChange"() {
				//alert("jinlai")
				/*console.log('....pdataChange')
				   console.log(val)
				   console.log(old)*/
				/*if (val === true) {
				   this.fetchData()
				   this.$store.dispatch('setEditChange','false')
				   }*/
				this.fetchData();
				//this.$store.dispatch('setEditChange','false')
			}
		},
		created() {
			this.fetchData();
			//alert(this.$store.getters.edit_change)

		},
		mounted() {

			var _this = this
			this.tqobj = {
				keys: ['taskType2', 'taskTypeArr2', 'sftype', 'comm'],
				callback: (data) => {
					_this.statusShow = data[0]
					_this.statusSl = data[1]
					_this.subtypes = data[2]
					_this.comm = data[3]
				}
			}
		},
		computed: {
			isCall() {
				////// 0 未激活 1激活
				return this.baseinfo.call_status == 1 ? true : false
			},
			isLockScreen() {
				return this.baseinfo.param === '0' ? false : true
			},
			ulscreentt() {
				return this.baseinfo.param === '0' ? this.$t('app_lokscrn') : this.$t('app_ulkscrn')
			},
			calltt() {
				return this.isCall ? this.$t('app_natpossp') : this.$t('app_actpossp')
			},
			sticon0() {
				var infos = this.baseinfo.online_history
				var key = infos ? infos[0].key : ''
				return key ? this.sticons[parseInt(key) - 1] : ''
			},
			sticon1() {
				var infos = this.baseinfo.online_history
				var key = infos ? infos[1].key : ''
				return key ? this.sticons[parseInt(key) - 1] : ''
			},
			sticon2() {
				var infos = this.baseinfo.online_history
				var key = infos ? infos[2].key : ''
				return key ? this.sticons[parseInt(key) - 1] : ''
			},
			stlb0() {
				var infos = this.baseinfo.online_history
				return infos ? this.lasword[infos[0].key - 1] : ''
			},
			stlb1() {
				var infos = this.baseinfo.online_history
				return infos ? this.lasword[infos[1].key - 1] : ''
			},
			stlb2() {
				var infos = this.baseinfo.online_history
				return infos ? this.norword[infos[2].key - 1] : ''
			},
			sttm0() {
				var infos = this.baseinfo.online_history
				return infos ? infos[0].value : ''
			},
			sttm1() {
				var infos = this.baseinfo.online_history
				return infos ? infos[1].value : ''
			},
			sttm2() {
				var infos = this.baseinfo.online_history
				return infos ? infos[2].value : ''
			},
			adbst(vl) {
				var vl = this.getTerAdbztInfo.adb_status
				if (!vl) {
					return ''
				} else {
					switch (vl) {
						case '1':
							return this.$t('app_on1')
							break
						case '2':
							return this.$t('app_off1')
							break
						default:
							return vl
					}
				}
			},
			dvst() {
				var vl = this.getTerAdbztInfo.debugModel
				if (!vl) {
					return ''
				} else {
					switch (vl) {
						case '0':
							return this.$t('app_normalmode')
							break
						case '1':
							return this.$t('app_debugmode')
							break
						default:
							return vl
					}
				}
			},
			signst() {
				var vl = this.getTerAdbztInfo.signActivated
				if (!vl) {
					return ''
				} else {
					switch (vl) {
						case '0':
							return this.$t('app_off1')
							break
						case '1':
							return this.$t('app_on1')
							break
						default:
							return vl
					}
				}
			},
			isChina() {
				// /// 孟加拉临时版本
				// return true

				if (localStorage.system_lang === "zh_cn") {
					return true;
				} else {
					return false;
				}
			},
			showRuntime() {
				var str = "";
				var arr = [];
				if (!this.baseinfo) {
					return "";
				}
				if (this.baseinfo.terminal_runtime_status === "0") {
					str = this.$t("app_normal");
				} else {
					if (this.baseinfo.terminal_runtime_msg) {
						arr = this.baseinfo.terminal_runtime_msg.split(",");
						if (arr) {
							arr.forEach(obj => {
								if (obj) {
									var sub = obj.split("_");
									str += this.rRuntime[sub[0]] + this.rType[sub[1]] + ",";
								}
							});
						}
					}
				}
				//str = isNaN(str) ? '' : str
				str = str ? str.substring(0, str.length - 1) : "";
				return str;
			}
		},
		components: {
			processInfo,
			ztMap,
			tyc
		},
		methods: {
			showFunc(row) {
				this.sendLoad = true
				this.$funcOpQuery(this.terNo, row.name, res => {
					this.sendLoad = false
					this.fclogs = res.data
					this.showfc = true
				}, () => {
					this.sendLoad = false
				})
			},
			closeulDia() {
				this.ulDia = false
				this.ulsform.psw = ''
				this.ulsform.time = ''
			},
			ulscreenOpe() {
				this.ulDia = true
			},
			ulscreenRqs() {
				var fm = this.ulsform
				this.disabled = 1
				var lstatus = this.isLockScreen ? '0' : '1'
				this.$loaunScreen(this.terNo, fm.psw, parseInt(fm.time), lstatus, res => {
						this.disabled = 0
						if (res.status === 200) {
							this.$message.success(res.message);
							this.fetchData()
							this.closeulDia()
						} else {
							this.$message.error(res.message);
						}
					},
					() => {
						this.disabled = 0
					}
				)
			},
			outputexcel() {
				this.$outputEq2Excel(this.terminalID, '', '', '', '', '', '', '')
			},
			callclick() {
				this.disabled = 1
				var _this = this
				var packageName = ''
				var type = this.isCall ? '0' : '1'
				this.$dvcmd('YCJHDH', type, packageName, this.terNo, res => {
						_this.disabled = 0;
						if (res.status === 200) {
							_this.$message.success(res.message);
							_this.fetchData();
						} else {
							_this.$message.error(res.message);
						}
					},
					() => {
						this.disabled = 0;
						// error
					}
				)
			},
			lockDevice(isLock) {
				if (isLock) {
					this.disabled = 1;
					var _this = this
					this.$lockDevice(this.terNo, res => {

							// this.delDeviceNo = 0
							_this.disabled = 0;
							if (res.status === 200) {
								_this.$message.success(res.message);
								_this.fetchData();
							} else {
								_this.$message.error(res.message);
							}
						},
						() => {
							this.disabled = 0;
							// error
						}
					);
				} else {
					this.disabled = 1;
					var _this = this
					this.$unlockDevice(this.terNo, function(res) {

							// this.delDeviceNo = 0
							_this.disabled = 0;
							if (res.status === 200) {
								_this.$message.success(res.message);
								_this.fetchData();
							} else {
								_this.$message.error(res.message);
							}
						},
						() => {
							this.disabled = 0;
							// error
						}
					);
				}

			},
			rqsPath() {
				// G011746020000
				var tno = this.terNo;
				this.$terHisPath(
					tno,
					res => {
						this.initPath(res.data);
					},
					error => {}
				);
			},
			get_lng_lat(bd_lng, bd_lat) {
				// --------------
				// 百度地图点转高德地图点
				var x_pi = Math.PI * 3000.0 / 180.0
				var x = Number(bd_lng - 0.0065),
					y = Number(bd_lat - 0.006);
				var z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * x_pi);
				var theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * x_pi);
				var gd_lng = Number(z * Math.cos(theta))
				var gd_lat = Number(z * Math.sin(theta))
				var result_form = {
					gd_lng: gd_lng,
					gd_lat: gd_lat
				}
				return result_form
				// --------------
			},
			showPolyLine(points, color, map) {
				/* points[][]数据结构为二维数组，这里转换为Marker，再将多个marker点放入pline，组成一条线  begin */
				var pLine = [];
				for (var i = 0; i < points.length; i++) {
					points[i].longitude = this.get_lng_lat(points[i].longitude, points[i].latitude).gd_lng
					points[i].latitude = this.get_lng_lat(points[i].longitude, points[i].latitude).gd_lat
				}
				for (var i = 0; i < points.length; i++) {
					var obj = points[i];
					var lon = obj.longitude;
					var lat = obj.latitude;
					pLine.push(new AMap.LngLat(lon, lat));
					var icon = new AMap.Icon({
						size: new AMap.Size(20, 24), //图标大小
						image: require('../../assets/images/icon_red.png'),
						imageSize: new AMap.Size(20, 24)
					});
					var marker = new AMap.Marker({
						icon: icon,
						offset: [-8, -22], //偏移量 x,y轴
						// position: new AMap.LngLat(lon, lat),
						position: [lon, lat],
					});
					if (i === 0) {
						var icon = new AMap.Icon({
							size: new AMap.Size(20, 24), //图标大小
							image: require('../../assets/images/icon_green.png'),
							imageSize: new AMap.Size(20, 24)

						});
						marker = new AMap.Marker({
							icon: icon,
							offset: [-8, -22], //偏移量 x,y轴
							// position: new AMap.LngLat(lon, lat),
							position: [lon, lat],
						});
						map.add(marker)
					}
					// marker.on('click', function(e) {
					// 	console.log(e)

					// 	var content = obj.locatime + "<br/><br/>" + obj.address;
					// 	var infoWindow = new AMap.InfoWindow({
					// 		anchor: 'bottom-right',
					// 	})
					// 	infoWindow.setContent(content);
					// 	infoWindow.open(map, e.target.getPosition());
					// })
					marker.on('click', function(e) {
						var p = e.target;

						// var point = new AMap.LngLat(p.getPosition().lng, p.getPosition().lat);
						var point = {
							lng:p._position[0],
							lat:p._position[1]
						} 
						console.log(e.target._position)
						var sobj = "";
						points.forEach(vl => {
							if (vl.latitude == point.lat && vl.longitude == point.lng) {
								sobj = vl;
							}
						});
						// console.log(sobj)
						var content = sobj.locatime + "<br/><br/>" + sobj.address;
						var infoWindow = new AMap.InfoWindow({
							anchor: 'bottom-right',
						})
						infoWindow.setContent(content);
						infoWindow.open(map, e.target.getPosition());
					})
					map.add(marker)

				}
				/* 添加轨迹接口begin */
				var polyline = new AMap.Polyline({
					path: pLine,
					strokeColor: color,
					strokeWeight: 6,
					strokeOpacity: 0.5,
				})
				// map.add(polyline);
				map.add([polyline]);
			},
			// add_maker(evt) {
			// 	this.point_map.marker.add({
			// 		id: this.point_map.point_id, // id
			// 		position: evt.latLng, // 传入当前点位坐标
			// 		styleId: "red_point",
			// 		properties: {
			// 			title: "marker"
			// 		}
			// 	});
			// 	this.point_map.point_id++
			// },
			initPath(paths) {
				if (paths.length === 0) {
					const map = new AMap.Map('allmap', {
						resizeEnable: true,
						viewMode: '3D',
						pinch: 45
					})
					AMap.plugin(['AMap.ControlBar', 'AMap.ToolBar', ], function() {
						map.addControl(new AMap.ControlBar({
							position: "RT" // 固定右上角
						}));
						map.addControl(new AMap.ToolBar({
							// 简易缩放模式，默认为 false
							liteStyle: true,
							position: "RT", // 固定右上角
							offset: [30, 110] //偏移量 x,y轴
						}));
					});

					map.setZoomAndCenter(15, [108.960679, 34.314287]); //同时设置地图层级与中心点
					var size = new AMap.Size(20, 20)
					return
				}


				const map = new AMap.Map("allmap", {
					resizeEnable: true,
					viewMode: '3D',
					pinch: 45
				});
				// 添加 3D 罗盘控制、缩放按钮
				AMap.plugin(['AMap.ControlBar', 'AMap.ToolBar', ], function() {
					map.addControl(new AMap.ControlBar({
						position: "RT" // 固定右上角
					}));
					map.addControl(new AMap.ToolBar({
						// 简易缩放模式，默认为 false
						liteStyle: true,
						position: "RT", // 固定右上角
						offset: [30, 110] //偏移量 x,y轴
					}));
				});
				map.setZoomAndCenter(15, [paths[0].longitude, paths[0].latitude]); //同时设置地图层级与中心点
				this.showPolyLine(paths, "red", map);
			},
			rfInfo() {
				this.systemInfoLoading = true;
				this.getTerXTXX();
			},
			rfNet() {
				this.peripheralLoading = true;
				this.getTerWLLX();
			},
			rfhw() {
				this.hardInfoLoading = true;
				this.getHardsInfo();
			},
			rfadb() {
				this.adbLoading = true
				this.getTerADBZT()
			},
			initGMap(mapCenter, pointArr, pointOrg) {
				if (!window.google) {
					return;
				}
				var map = new google.maps.Map(document.getElementById("gmap"), {
					zoom: 15,
					center: mapCenter
				});

				if (pointOrg) {
					// 折线参数
					var polylineOptions = {
						path: pointOrg,
						geodesic: true, // 可测量的
						strokeColor: "red", // 线条颜色
						strokeOpacity: 0.8, // 透明度 50%
						strokeWeight: 5 // 宽度 5像素
					};
					// 创建一个Polyline的实例
					var polyline1 = new window.google.maps.Polyline(polylineOptions);
					polyline1.setMap(map); // 设置显示到map上

					if (pointArr) {
						var spicon = require("../../assets/images/icon_green.png");
						var iconRed = require("../../assets/images/icon_red.png");
						pointArr.forEach(function(item, index) {
							var mk = new google.maps.Marker({
								position: item.point,
								map: map,
								icon: index === 0 ? spicon : item.icon
							});
							var ct = item.content;
							var infowindow = new google.maps.InfoWindow({
								content: ct,
								maxWidth: 200
							});
							mk.addListener("click", function() {
								if (window.preInfoView) {
									window.preInfoView.close(map, mk);
								}
								window.preInfoView = infowindow;
								infowindow.open(map, mk);
							});
						}, this);
					}
				}
			},
			showPathMap() {
				this.mapDialog = true;
				if (this.isChina) {
					//this.mapdata1.sn = this.terNo
					this.rqsPath();
				} else {
					this.$terHisPath(
						this.terNo,
						res => {
							var ps = [];
							var p = [];
							var center = {
								lat: 23.5,
								lng: 123.3
							};
							if (res.data.length > 0) {
								var center = new window.google.maps.LatLng(
									res.data[0].latitude,
									res.data[0].longitude
								);
							}

							res.data.forEach(vl => {
								p.push(new window.google.maps.LatLng(vl.latitude, vl.longitude));
								ps.push({
									point: new window.google.maps.LatLng(vl.latitude, vl.longitude),
									//icon: icon,
									content: vl.locatime + "<br><br>" + vl.address,
									//iconName: iconName,
									width: 200
								});
							});
							//console.log(center,ps,p)

							this.initGMap(center, ps, p);
						},
						error => {}
					);
				}
			},
			refreshList() {
				this.getList();
			},
			repush(row) {
				//console.log(row)
				var _this = this
				this.loading = 1
				this.$pushRepush(
					row.taskId,
					res => {
						// this.delDeviceNo = 0

						_this.loading = 0;
						if (res.status === 200) {
							_this.$message.success(res.message);
							_this.getList();
						} else {
							_this.$message.error(res.message);
						}
					},
					() => {
						this.loading = 0;
						// error
					}
				);
			},
			t1() {
				if (window.t1) {
					clearTimeout(window.t1);
					window.t1 = "";
				}

				var istd = this.$route.path.indexOf('terList/') != -1 && this.$route.path.indexOf('/details') != -1
				if (!istd) return;
				/////////////////

				var arr = [];

				this.tableData1.forEach((vl, index) => {
					//console.log(vl)
					if (vl.status == 1) {
						// 1
						arr.push({
							value: vl,
							index: index
						});
					}
				});
				if (arr.length === 0) {
					return;
				}

				// param
				var ids = "";
				arr.forEach((vl, index) => {
					ids += vl.value.taskId + ",";
				});
				ids = ids.substring(0, ids.length - 1);
				var _this = this;
				// rqs
				var _this = this;
				this.$missionPersent(
					ids,
					res => {
						window.t1 = setTimeout(() => {
							_this.t1();
						}, this.dur);

						if (res.status === 200) {
							console.log(res);
							var data = res.data;
							arr.forEach((vl, index) => {
								var obj = data[index];
								if (obj.result) {
									this.tableData1[vl.index].progress = obj.result.progress;
									this.tableData1[vl.index].status = parseInt(obj.result.status);
									if (obj.result.status == 2) {
										this.t2();
									}
								}
							});
						} else {
							//this.$message.error(res.data.message)
						}
					},
					() => {
						// error
					}
				);
			},
			t2() {
				if (window.t2) {
					clearTimeout(window.t2);
					window.t2 = "";
				}

				var istd = this.$route.path.indexOf('terList/') != -1 && this.$route.path.indexOf('/details') != -1
				if (!istd) return;
				/////////////////
				var arr = [];
				this.tableData1.forEach((vl, index) => {
					if (vl.status == 2 || vl.status == 4) { // 4等待中
						// 1
						arr.push({
							value: vl,
							index: index
						});
					}
				});
				if (arr.length === 0) {
					return;
				}

				var _this = this;
				// rqs
				var _this = this;
				var tNo = this.terNo ? this.terNo : "";
				var type = this.taskType ? this.taskType : "";
				var fName = this.tName ? this.tName : "";
				var page = this.$getWPage(_this.pageTag);
				page = page ? page : 1;
				this.$pushTaskList(
					this.$gRow,
					page,
					tNo,
					type,
					fName,
					res => {
						window.t2 = setTimeout(() => {
							_this.t2();
						}, this.dur);
						if (res.status === 200) {
							var data = res.data;
							// console.log('dddddd', data)
							arr.forEach((vl, index) => {
								var obj = data[vl.index];

								this.tableData1[vl.index].status = parseInt(obj.status);
							});
						} else {
							//this.$message.error(res.data.message)
						}
					},
					() => {
						// error
					}
				);
			},
			delRow(row) {
				this.$showConfirm(
					"",
					this.$t("app_isDelData"),
					this.$t("app_sure"),
					this.$t("app_cancel"),
					"warnning",
					() => {
						// sure
						//console.log(row)
						var id = row.taskId;
						this.loading = 1;
						this.$pushDelTask(
							id,
							res => {
								// this.delDeviceNo = 0
								this.loading = 0;
								if (res.status === 200) {
									this.getList();
								} else {
									this.$message.error(res.message);
								}
							},
							() => {
								this.loading = 0;
								// error
							}
						);
					}
				);
				// console.log(row)
			},
			downOperate(vl, row) {
				this.loading = 1;
				var id = row.taskId
				this.$pushFileDownCtrl(
					id,
					vl + "",
					this.terNo,
					res => {
						this.loading = 0;
						if (res.status === 200) {
							this.getList();
							this.$message.success(res.message)
						} else {
							this.$message.error(res.message);
						}
					},
					() => {
						this.loading = 0;
						// error
					}
				);
			},
			query() {
				this.getList();
			},
			selectChange() {
				this.getList();
			},
			showBtn(tag, st) {
				// tag 0删除 1暂停 2继续 3取消 4重推
				//
				// 新状态，modify by sing, 2017-06-17
				// st -1： 下载失败， -2： MD5校验失败， -3： 已经是最新版本，
				// -4： 文件格式不正确（不是apk文件）， -5： 更新失败，-6：用户取更，
				// 1： 下载中，返回下载进度，2： 下载完成， 3： 更新成功，6暂停 7取消
				var vl = st;
				// console.log('tag is ' + tag + ',status: ' + JSON.stringify(st));
				// alert(st)
				switch (vl) {
					case -1:
					case -2:
					case -3:
					case -4:
					case -5:
					case 4:
					case -6:
					case 3:
					case 0:
					case -7:
					case 7:
					case 2:
						if (tag == 0) {
							return 1;
						} else if (tag == 4) {
							if (vl == 7) { //vl == -1 || vl == -2 || vl == -5
								return 1;
							} else {
								return 0;
							}
						} else {
							return 0;
						}
						break;
					case 1:
						if (tag == 1 || tag == 3) {
							return 1;
						} else {
							return 0;
						}
						break;
					case 6:
						if (tag == 2) {
							return 1;
						} else {
							return 0;
						}
						break;

				}
				//updateTimer
			},
			getList() {

				var tNo = this.terNo ? this.terNo : "";
				var type = this.taskType ? this.taskType : "";
				var fName = this.tName ? this.tName : "";
				var page = this.$getWPage(this.pageTag);
				page = page ? page : 1;
				this.$pushTaskList(
					this.$gRow,
					page,
					tNo,
					type,
					fName,
					res => {
						this.loading = 0;
						if (res.status === 200) {

							this.tableData1 = res.data;
							this.total = res.total;

							this.t1();
							this.t2();

						} else {
							this.$message.error(res.message);
						}
					},
					() => {
						this.loading = 0;
						// error
					}
				);
			},
			pageSelect(index) {
				this.$setWPage(this.pageTag, index);
				this.getList();
			},
			pageSelectDv(index) {
				this.$setWPage(this.pageTag, index);
				this.getList();
			},
			pageSized(val) {
				this.$gRow = val;
				this.getList();
			},
			getLog: function() {
				var params = {
					beginTime: this.start_time,
					endTime: this.end_time,
					terminalNo: this.terNo
				};
				//console.log("打印氚餐");
				//console.log(params)
				axios.post(`${baseurl}/terminalLog/getLogs.do`, params).then(res => {
					this.logLoad = true;
					if (res.data.status == 200) {
						this.$message.success(this.$t("lin_global.rz_tips"));
						this.logLoad = false;
						this.logDialog = false;
					} else {
						this.$message.error(res.data.message);
						this.logLoad = false;
						//this.logDialog = false;
					}
				});
			},
			dataChange: function(value) {
				this.start_time = value;
			},
			dataChange1: function(value) {
				this.end_time = value;
			},
			statusType: function(row, column) {
				// var types = [this.$t("terminal.details.animate"),
				// this.$t("terminal.details.kjlogo"),
				// this.$t('app_deskwp')]
				// var index = parseInt(row.animatType)
				// return types[index - 1] ? types[index - 1]: '';

				return this.statusShow[row.fileType]
			},
			formatStatus: function(row, column) {
				// return row.position == 1
				//   ? this.$t("terminal.details.kj")
				//   : row.position == 2
				//     ? this.$t("terminal.details.gj")
				//     : row.position == 3
				//       ? this.$t("terminal.details.kgj")
				//       : this.$t("terminal.details.kjlogo");
				return this.subtypes[row.subFileType]
			},
			send(row) {
				// var params = { terminalNo: this.terNo, animatId: id, memo: "" };
				this.$confirm(
						this.$t("terminal.details.comfirm_send"),
						this.$t("lin_btn.tips"), {
							confirmButtonText: this.$t("lin_btn.confirm"),
							cancelButtonText: this.$t("lin_btn.cancel"),
							type: "warning"
						}
					)
					.then(() => {
						this.sendLoad = true;
						// axios
						//   .post(`${baseurl}/boot_animat/pushByTerNo.do`, params)
						//   .then(res => {
						//     //console.log("推送")
						//     //console.log(res.data);
						//     if (res.data.status == 200) {
						//       this.$message.success(this.$t("lin_global.task_tips2"));
						//       this.sendLoad = false;
						//       this.sendAnimateDialog = false;
						//     } else {
						//       //console.log(res.data.message)
						//       this.$message.error(res.data.message);
						//       this.sendLoad = false;
						//       this.sendAnimateDialog = false;
						//     }
						//   });
						this.$filePushTest(row.fileId, this.terNo, res => {
							this.sendLoad = false
							this.sendAnimateDialog = false
							if (res.status == 200) {
								this.$message.success(this.$t("lin_global.task_tips2"));
							} else {
								this.$message.error(res.message);
							}
						}, '')
					})
					.catch(() => {});
			},
			getAnimate() {
				this.tloading = true;
				// axios.post(`${baseurl}/boot_animat/animatList.do`, {}).then(res => {
				//   //console.log("guanggao信息")
				//   //console.log(res.data);
				//   if (res.data.status == 200) {
				//     this.tloading = false;
				//     this.tableData = res.data.data;
				//   } else {
				//     this.tloading = false;
				//   }
				// });
				var mech = '' //渠道商id
				var name = ''
				var type = '3'
				var stype = ''
				var st = '2'

				this.$getfile(1, 999, name, mech, type, stype, st, '', '', (res) => {

					this.tloading = false
					if (res.status === 200) {
						this.total = res.total
						this.tableData = res.data
					} else {
						this.$message(res.message)
					}
				}, () => {
					this.loading = 0
					this.$message.error(this.$t('app_rqsError'))
				})
			},
			sendAnimate() {
				this.sendAnimateDialog = true;
				this.getAnimate();
				/*var params = {id:'53c2c170-10b0-4575-9cf5-b7a6ae9ea236'};
				   axios.post(`${baseurl}/advertisement/detail.do`,params).then(res=>{
				   console.log("guanggao信息")
				   console.log(res.data);
				   })*/
			},
			getHardsInfo() {
				var params = {
					terminalNo: this.terNo
				};
				axios.post(`${baseurl}/terminal/sysInfo.do`, params).then(res => {
					if (res.data.status == 200) {
						//console.log("打印硬件参数");
						//console.log(res.data.data);
						//this.hardwareInfo = JSON.parse(res.data.data);
						this.hardwareInfo = res.data.data;
						this.hardInfoLoading = false;
					} else {
						//this.$message.error(res.data.message)
						this.hardInfoLoading = false;
					}
				});
			},
			fetchData() {
				//this.fetchBaseinfo();

				/*this.terminalStatus();
				   this.getSystemInfo();
				   this.getHardInfo();*/
				this.fetchInfo();
				//this.getAnimate();

				//this.linklog();
				/*var no = this.$store.getters.ter_param.terNo;
				   this.terNo = localStorage.getItem('terNo');*/
				/*if(no){*/
				//this.$store.dispatch('setParam',null)
				//this.linkLog = '/terList/'+this.$route.params.id+'/terAppLog/'+this.$route.params.no;
				//this.linkBind = '/terList/'+this.$route.params.id+'/terAppBind/'+this.$route.params.no;
				/*}*/
			},
			/*linklog:function(){
			   console.log("ddd")
			   console.log(this.terminalNo)
			   this.linkLog = '/terList/'+this.$route.params.id+'/terAppLog/'+this.terminalNo
			   },*/
			onCancel: function() {
				this.animateDialog = false;
			},
			submit: function() {
				var params = {
					type: this.animateId,
					terminalNo: this.terNo
				};
				if (this.animateId) {
					this.$confirm(
							this.$t("terminal.details.comfirm_hy"),
							this.$t("lin_btn.tips"), {
								confirmButtonText: this.$t("lin_btn.confirm"),
								cancelButtonText: this.$t("lin_btn.cancel"),
								type: "warning"
							}
						)
						.then(() => {
							this.logining = true;
							axios.post(`${baseurl}/boot_animat/clear.do`, params).then(res => {
								//console.log("还原")
								//console.log(res.data);
								if (res.data.status == 200) {
									this.$message.success(this.$t("terminal.details.hy_success"));
									this.logining = false;
									//this.sendAnimateDialog = false;
									this.animateDialog = false;
								} else {
									this.$message.error(res.data.message);
									this.logining = false;
									this.animateDialog = false;
								}
							});
						})
						.catch(() => {});
				} else {
					this.$message.error(this.$t("terminal.details.hy_type"));
				}
			},
			animate: function() {
				this.animateDialog = true;
			},
			ToLinkList: function() {
				this.$setWObj('tdToList', this.terNo)
				this.$router.push({
					path: this.linkto
				});
			},
			ToLinkLog: function() {
				/*this.$router.push({path:this.linkLog})*/
				this.logDialog = true;
			},
			ToLink: function() {
				//console.log(this.baseinfo)

				this.$setWObj("terminalInfo", this.baseinfo);
				this.$router.push({
					path: "/terList/" + this.$route.params.id + "/terAppBind/" + this.terNo
				});
			},
			linkRisk: function() {
				this.$router.push({
					path: "/terList/" + this.$route.params.id + "/terRisk"
				});
			},
			getTerXTXX: function() {
				var params = {
					terminal_no: this.terNo
				};
				axios.post(`${baseurl}/terminal/getTerXTXX.do`, params).then(res => {
					if (res.data.status == 200) {
						//console.log("打印系统信息");
						//console.log(res.data.data);
						this.getTerXtxxInfo = res.data.data;
						this.systemInfoLoading = false;
					} else {
						this.systemInfoLoading = false;
						//this.$message.error(res.data.message)
					}
				});
			},
			getTerADBZT: function() {
				var url = `${baseurl}/terminal/getTerADBZT.do`;
				var params = {
					terminal_no: this.terNo,
					terminal_id: this.terminalID
				};
				//console.log(url, params)
				axios.post(url, params).then(res => {
					this.adbLoading = false
					if (res.data.status == 200) {
						//console.log("打印ADB信息");
						// console.log('adbadbadb', res.data.data);

						this.getTerAdbztInfo = res.data.data;

						/*
						// comment by sing,20180909
						// 改在获取网络类型中进行判断
						if (res.data.data.terminal_status === "1") {
						  this.btnShow = false;
						} else {
						  this.btnShow = true;
						}
						if (res.data.data.adb_status == 0) {
						  this.adb = this.$t("terminal.details.open_abd");
						  this.abdOpe = "0";
						} else {
						  this.adb = this.$t("terminal.details.close_abd");
						  this.abdOpe = "1";
						}
						*/
					} else {
						//this.$message.error(res.data.message)
					}
				});
			},
			getTerWLLX: function() {
				var params = {
					terminal_no: this.terNo
				};
				this.peripheralLoading = true;
				axios.post(`${baseurl}/terminal/getTerWLLX.do`, params).then(res => {
					this.peripheralLoading = false;
					if (res.data.status == 200) {
						//console.log("打印网络信息");
						//console.log(res.data.data);
						this.getTerWllxInfo = res.data.data;

						this.baseinfo.online_history = res.data.data.online_history

						if (this.getTerWllxInfo.terminal_status === "1" || this.getTerWllxInfo
							.terminal_status === "3") {
							this.btnShow = false
							this.isRf = true
						} else {
							this.btnShow = true
							this.isRf = false
						}


					} else {
						//this.$message.error(res.data.message)

					}
				});
			},
			fetchInfo() {

				var params = {
					terminal_id: this.terminalID
				};
				axios.post(`${baseurl}/terminal/detail.do`, params).then(res => {
					var res1 = res.data.data ? res.data.data : ''
					var fst = res1.factoryStatus ? res1.factoryStatus : ''
					var ast = res1.activStatus ? res1.activStatus : ''
					this.showFac = fst == 1 ? true : false;
					this.showAct = ast == 2 ? true : false;

					if (res.data.status == 200) {
						this.baseinfo = res.data.data;
						this.disabled = false;
						//console.log("打印ABD状态");
						//console.log(res.data.data.adb_status);
						if (res.data.data.adb_status == 0) {
							this.adb = this.$t("terminal.details.open_abd");
							this.abdOpe = "0";
						} else {
							this.adb = this.$t("terminal.details.close_abd");
							this.abdOpe = "1";
						}

						this.terNo = res.data.data.terminal_no;
						this.terminalNo = res.data.data.terminal_no;
						this.pdata.terminalNO = res.data.data.terminal_no;
						this.pdata.terminal_name = res.data.data.terminal_name;
						this.pdata.terminal_model = res.data.data.terminal_model;
						this.pdata.terminal_type = res.data.data.terminal_type;
						this.pdata.areaid = res.data.data.mechanismId;
						this.pdata.manufid = res.data.data.manufId;
						this.pdata.address = res.data.data.address;
						this.pdata.memo = res.data.data.memo;
						// this.pdata.terminalCreateTime = res.data.data.terminalCreateTime;
						// this.pdata.expirationTime = res.data.data.expirationTime;
						this.pdata.mechanismName = res.data.data.mechanismName
						this.linkLog =
							"/terList/" +
							this.$route.params.id +
							"/terAppLog/" +
							res.data.data.terminal_no;
						this.linkBind =
							"/terList/" +
							this.$route.params.id +
							"/terAppBind/" +
							res.data.data.terminal_no;
						// cg

						this.getTerADBZT();
						this.getTerXTXX();
						this.getTerWLLX();
						//this.getHardsInfo();
						this.$mdOpQuery(this.terminalNo, res => {
							this.mdlogs = res.data
						}, '')

						/// set below card data

						/*
						this.getTerAdbztInfo.terminal_status = res.data.data.terminal_status;
						if (this.getTerAdbztInfo.terminal_status === "1") {
						  this.btnShow = false;
						  this.isRf = true;
						} else {
						  this.btnShow = true;
						  this.isRf = false;
						}
						*/

						this.getTerXtxxInfo.launcher = res.data.data.launcher;
						this.getTerXtxxInfo.ota = res.data.data.ota;
						this.hardwareInfo.system = res.data.data.system;
						this.getTerXtxxInfo.firmware = res.data.data.firmware;
						this.getTerXtxxInfo.elapsedtime = res.data.data.elapsedtime;

						this.getTerWllxInfo.wlan = res.data.data.wlan;

						this.hardwareInfo.cpu = res.data.data.cpu;
						this.hardwareInfo.cpuUsed = res.data.data.cpuUsed;
						this.hardwareInfo.mem = res.data.data.mem;
						this.hardwareInfo.memUsed = res.data.data.memUsed;
						// end

						if (this.terNo) {
							setTimeout(() => {
								this.getList();
							}, 500);
						}
					} else {
						this.disabled = false;
						this.$message.error(res.data.message);
					}

					//this.terminalNo = res.data.data.terminal_no;
				});
			},
			clickAbd() {
				var params = {
					terminal_id: this.terminalID,
					terminal_no: this.terNo,
					adb_status: this.abdOpe
				};
				var text = "";
				if (this.abdOpe == "0") {
					text = this.$t("terminal.details.open_abd");
				} else {
					text = this.$t("terminal.details.close_abd");
				}
				/*是否进行${text}操作？*/
				this.$confirm(
						this.$t("terminal.details.if_ope"),
						this.$t("lin_btn.tips"), {
							confirmButtonText: this.$t("lin_btn.confirm"),
							cancelButtonText: this.$t("lin_btn.cancel"),
							type: "warning"
						}
					)
					.then(() => {
						this.adbLoad = true;
						axios.post(`${baseurl}/terminal/abdConvert.do`, params).then(res => {
							//console.log("abd信息")
							//console.log(res.data);
							if (res.data.status == 200) {
								this.$message({
									type: "success",
									message: this.$t("lin_global.success_tips")
								});
								this.adbLoad = false;
								this.getTerADBZT();
							} else {
								this.$message(res.data.message);
								this.adbLoad = false;
							}
						});
					})
					.catch(() => {
						this.$message({
							type: "info",
							message: this.$t("lin_global.concel_tips")
						});
					});
			},
			log() {
				let rq = {
					condition: {
						terminal_no: self.baseinfo.terminal_no,
						order_type: order,
						order_content: ""
					}
				};
			},
			orderExec: function(order) {
				let text = {
					CQ: this.$t("lin_btn.restart"),
					GJ: this.$t("terminal.details.gj"),
					HFCCSZ: this.$t("terminal.details.regain")
				};
				this.$confirm(
						this.$t("lin_global.qrjxmm") +
						text[order],
						this.$t("lin_btn.tips"), {
							confirmButtonText: this.$t("lin_btn.confirm"),
							cancelButtonText: this.$t("lin_btn.cancel"),
							type: "warning"
						}
					)
					.then(() => {
						this.execNo = order;
						//let self = this
						if (order === "CQ") {
							this.cqLoad = true;
						} else if (order === "GJ") {
							this.gjLoad = true;
						} else {}
						//          let rq = {
						//            condition: {
						//              'terminal_no': this.baseinfo.terminal_no,
						//              'order_type': order,
						//              'order_content': ''
						//            }
						//          }

						var that = this;

						if (order === "HFCCSZ") {
							this.hfszLoad = true;
						} else if (order === "ZJ") {
							this.zjLoad = true;
						}

						that.req.order
							.shutdownOrRestartTerminal({
									terminalNo: that.baseinfo.terminal_no,
									orderType: order
								},
								that.$t("lin_global.zlxfs_tips"),
								that.$t("lin_global.zl_error")
							)
							.then(() => {
								that.cqLoad = false;
								that.gjLoad = false;
							});
						//console.log("打印所传参数");
						//console.log(rq);
						//          this.$httpzi.post("terminalManagement/monitor/orderExec", rq).then( (response)=> {
						//            let rs = response.data
						//            this.execNo = ''
						//            //console.log("打印下发指令参数")
						//            //console.log(rs)
						//            if (rs.errorCode === '00') {
						//              // self.catchPicList.push(rs.data)
						//              this.$message.success({
						//                duration: 3000,
						//                showClose: true,
						//                message: this.$t('lin_global.zlxfs_tips')
						//              })
						//              this.cqLoad = false;
						//              this.gjLoad = false;
						//            } else if(rs.errorCode === '92') {
						//              this.$message.error({
						//                duration: 3000,
						//                showClose: true,
						//                message: this.$t('lin_global.sb_tips')
						//              })
						//              this.cqLoad = false;
						//              this.gjLoad = false;
						//            }else{
						//              this.$message.error({
						//                duration: 3000,
						//                showClose: true,
						//                message: this.$t('lin_global.czsb')
						//              })
						//              this.cqLoad = false;
						//              this.gjLoad = false;
						//            }
						//          }).catch(function (error) {
						//            this.execNo = ''
						//            this.$message.error(this.$t('lin_global.zl_error'));
						//            this.cqLoad = false;
						//            this.gjLoad = false;
						//          })
					})
					.catch(() => {});
			},
			opeTer(type) {
				var that = this;
				that.req.order
					.tranOrderToTerminal({
							terminalNo: that.baseinfo.terminal_no,
							orderType: "HFCCSZ",
							type: type
						},
						that.$t("lin_global.zlxfs_tips"),
						that.$t("lin_global.zl_error")
					)
					.then(res => {
						that.hfszLoad = false;
						that.zjLoad = false;
						// self.hardInfo = response.data.data
						that.showReset = false;
					});
			},
			orderExec1: function(order) {
				let text = {
					HFCCSZ: this.$t("terminal.details.regain"),
					ZJ: "自检"
				};
				this.$confirm(
						this.$t("lin_global.qrjxmm") +
						text[order],
						this.$t("lin_btn.tips"), {
							confirmButtonText: this.$t("lin_btn.confirm"),
							cancelButtonText: this.$t("lin_btn.cancel"),
							type: "warning"
						}
					)
					.then(() => {
						if (order === "HFCCSZ") {
							this.hfszLoad = true;
						} else if (order === "ZJ") {
							this.zjLoad = true;
						} else {}
						//let self = this
						let rq = {
							condition: {
								terminal_no: this.baseinfo.terminal_no,
								order_type: order,
								order_content: ""
							}
						};

						var that = this;
						that.req.order
							.tranOrderToTerminal({
									terminalNo: that.baseinfo.terminal_no,
									orderType: order
								},
								that.$t("lin_global.zlxfs_tips"),
								that.$t("lin_global.zl_error")
							)
							.then(res => {
								that.hfszLoad = false;
								that.zjLoad = false;
								// self.hardInfo = response.data.data
							});

						//          this.$httpzi.post("terminalManagement/monitor/orderTrans", rq).then( (response)=> {
						//            let rs = response.data
						//            this.execNo = ''
						//
						//            console.log("打印下发指令参数")
						//            console.log(rs)
						//            if (rs.errorCode === '00') {
						//              // self.catchPicList.push(rs.data)
						//              this.$message.success({
						//                duration: 3000,
						//                showClose: true,
						//                message: this.$t('lin_global.zlxfs_tips')
						//              });
						//              this.hfszLoad = false;
						//              this.zjLoad = false;
						//              // self.hardInfo = response.data.data
						//            } else {
						//              this.$message.error({
						//                duration: 3000,
						//                showClose: true,
						//                message: this.$t('lin_global.zl_error')
						//              });
						//              this.hfszLoad = false;
						//              this.zjLoad = false;
						//            }
						//          }).catch(function (error) {
						//            this.execNo = '';
						//            this.hfszLoad = false;
						//            this.zjLoad = false;
						//            this.$message.error(this.$t('lin_global.zl_error'));
						//          })
					})
					.catch(() => {});
			}
		}
	};
</script>


// WEBPACK FOOTER //
// details.vue?2c0eda48